import { useEffect, useRef } from 'react';
import { doc, onSnapshot, updateDoc, deleteField, getDoc } from 'firebase/firestore';
import db from '@services/firebase-service';

const useErrorListener = (disableListener, streamId, cb) => {
  const lastHandledErrorRef = useRef('');

  const resetFSError = async (docRef) => {
    try {
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        await updateDoc(docRef, { error: deleteField() });
      }
    } catch {
      // Silently ignore if document doesn't exist
    }
  };
  useEffect(() => {
    if (disableListener) return undefined;
    const docRef = doc(db, 'streams', streamId);
    let unsub;
    lastHandledErrorRef.current = '';

    const getErrorKey = (error) => {
      if (typeof error === 'string') return error;
      try {
        return JSON.stringify(error);
      } catch {
        return String(error);
      }
    };

    const setupListener = async () => {
      await resetFSError(docRef);
      unsub = onSnapshot(docRef, async (document) => {
        if (document.exists()) {
          const error = document.get('error');
          if (!error) return;

          const errorKey = getErrorKey(error);
          if (errorKey === lastHandledErrorRef.current) return;

          lastHandledErrorRef.current = errorKey;
          await cb(error, document.id);

          try {
            await updateDoc(docRef, { error: deleteField() });
          } catch {
            // Ignore race conditions if another client already cleared this error
          }
        }
      }, (error) => {
        console.error('[useErrorListener] Snapshot error:', error);
      });
    };

    setupListener();

    return () => unsub?.();
  }, [streamId, disableListener, cb]);
};

export default useErrorListener;
